import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { Link } from "react-router-dom";
import { db } from "../../firebase";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import Offerimg from "../../Images/Serviceimg/offerimg.png";
import "../Bathroom/Bathroom.css";
import "react-loading-skeleton/dist/skeleton.css";
import { Rate, message } from "antd";
import Loading1 from "../../Components/Loading/Loading1";
import Sofacleaningvideo from "../../videos/Sofacleaningvideo.mp4";
import HomeNav from "../../Components/Navbar/NewNavbar";
import SofaCleaningInfo from "./SofaCleaningInfo";
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import DetailsModal from '../../Components/DetailsModal/DetailsModal';
import EmptyCartImg from "../../Images/Serviceimg/abandoned-cart.png";
import DiscountIcon from '@mui/icons-material/Discount';

const Sofacleaning = () => {
  const [services, setServices] = useState([]);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [videoUrl, setVideoUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null); // New state to handle selected service

  const navigate = useNavigate();

  useEffect(() => {
    const fetchServices = async () => {
      const servicesCollectionRef = collection(db, "services", "sofa", "0");
      const querySnapshot = await getDocs(servicesCollectionRef);
      let servicesList = [];
      querySnapshot.forEach((doc) => {
        servicesList.push({ id: doc.id, ...doc.data() });
      });
      setServices(servicesList);
      setLoading(false);
    };

    const fetchVideoUrl = async () => {
      const storage = getStorage();
      const videoRef = ref(storage, "serviceVideos/SofaVideo/CleaningVideo1.mp4");
      try {
        const url = await getDownloadURL(videoRef);
        setVideoUrl(url);
      } catch (error) {
        console.error("Error fetching video URL:", error);
      }
    };

    fetchServices();
    fetchVideoUrl();
    setCart(JSON.parse(localStorage.getItem("cart")) || []);
  }, []);

  const GoToCart = () => {
    navigate("/cart");
  };
  const calculateTotalPrice = () => {
    return cart.reduce((total, item) => total + item.discountedPrice * item.qty, 0);
  };
  const increaseQty = (index) => {
    const updatedCart = [...cart];
    updatedCart[index].qty += 1;
    setCart(updatedCart);
  };

  const decreaseQty = (index) => {
    const updatedCart = [...cart];
    if (updatedCart[index].qty > 1) {
      updatedCart[index].qty -= 1;
    } else {
      updatedCart.splice(index, 1); // Remove item if quantity is 0
    }
    setCart(updatedCart);
  };
  const addToCart = (service) => {
    let cartItems = [...cart];
    const existingIndex = cartItems.findIndex((item) => item.id === service.id);

    if (existingIndex > -1) {
      cartItems[existingIndex].qty += 1;
    } else {
      service.qty = 1;
      cartItems.push(service);
    }

    localStorage.setItem("cart", JSON.stringify(cartItems));
    message.success("Item Added in Cart");
    setCart(cartItems);
  };

  const openModal = (service) => {
    setSelectedService(service); // Set selected service for modal
    setIsOpen(true); // Open modal
  };

  const closeModal = () => {
    setIsOpen(false); // Close modal
    setSelectedService(null); // Clear selected service
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  if (isLoading) {
    return <Loading1 />;
  }

  const skeletonProps = {
    baseColor: "#ddd",
    highlightColor: "#eee",
  };

  return (
    <>
      <HomeNav />
      <div className="container my-5">
        <div className="row">
          <div className="minicart-video">
            <div className="minicart-container1">
              <h1 className="display-4">Sofa Cleaning</h1>
              <h3>
                At Astra Clean, we offer professional sofa cleaning services to
                restore the freshness and appearance of your upholstery. Our
                team uses advanced cleaning techniques and eco-friendly products
                to remove stains, dirt, and odors, ensuring your sofa looks and
                feels like new.
              </h3>
              <div className="service-rating">

                <div className="ratings-service">
                  <div className="rating-title">Average Rating</div>
                  <div className="rating-descreption">
                    <span style={{ fontSize: "25px", fontWeight: "500" }}>
                      4.6
                    </span>
                    <Rate
                      allowHalf
                      defaultValue={4.6}
                      className="ratingcolor"
                      disabled
                    />
                  </div>
                  <div className="rating-year">Average rating on this year</div>
                </div>
              </div>
            </div>
            <div className="minicart-container2">
              <div className="minicart-container2-subcontainer">
                <div className="minicart-container2-video">
                  {loading ? (
                    <div className="video-skeleton">
                      <Skeleton height={500} width={800} {...skeletonProps} />
                    </div>
                  ) : (
                    <video src={Sofacleaningvideo} autoPlay loop muted></video>
                  )}
                </div>
                <div className="minicart-container2-carts">
                  <div className="other-services">
                    {loading
                      ? Array.from({ length: 10 }).map((_, index) => (
                        <Skeleton
                          key={index}
                          height={200}
                          width={600}
                          {...skeletonProps}
                        />
                      ))
                      : services.map((service) => (
                        <div key={service.id} className="col-md-4 my-3">
                          <div className="card service-card">
                            <div className="card-service-card-container">
                              <img
                                src={service.img}
                                className="card-img-top"
                                alt={service.name}
                              />
                              <div className="card-body">
                                <h5 className="card-title">{service.name}</h5>
                                <ul className="card-text">
                                  {(Array.isArray(service.description)
                                    ? service.description
                                    : [service.description]
                                  ).map((point, index) => (
                                    <li key={index}>
                                      {point.length > 50 ? `${point.substring(0, 50)}...` : point}
                                    </li>
                                  ))}
                                </ul>
                                <div className="rating-container">
                                  {/* Display numerical rating */}
                                  <span
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: "600",
                                      marginRight: "7px",
                                    }}
                                  >
                                    {service.rating}
                                  </span>

                                  {/* Display star rating with precision */}
                                  <Box component="div" mt={0.8}>
                                    <Rating
                                      name="rating"
                                      value={service.rating} // Use service.rating here
                                      precision={0.1} // Allow precision to 0.1 for floating numbers
                                      size="medium"
                                      readOnly // Prevent users from changing the rating
                                    />
                                  </Box>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer">
                              <div className="pricesofservices">
                                <span className="originalprice">
                                  Rs.{service.originalPrice}
                                </span>
                                <span className="price">
                                  Rs.{service.discountedPrice}
                                </span>
                              </div>
                              <div className="btn-cartpage">
                                <button
                                  className="btn btn-add"
                                  onClick={() => addToCart(service)}
                                >
                                  Add to Cart
                                </button>
                                <button
                                  className="btn btn-add"
                                  onClick={() => openModal(service)} // Open modal with selected service
                                >
                                  View Details
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="offers-deiscount">
                    <div className="cart-services-page">

                      {cart.length > 0 ? (
                        <>
                          <div className="cart-name" style={{ fontWeight: 400 }}>Cart</div>
                          {/* <p>Total Items: {cart.length}</p> */}
                          <ul>
                            {cart.map((item, index) => (
                              <li key={index}>
                                <span style={{ fontWeight: 400, fontSize: '0.8rem' }} className="service-price-span">{item.name}</span>
                                <div className="services-cart-btns">
                                  <button onClick={() => increaseQty(index)}>+</button>
                                  <span>{item.qty}</span>
                                  <button onClick={() => decreaseQty(index)}>-</button>
                                </div>
                                Rs.{item.discountedPrice}
                              </li>
                            ))}
                          </ul>
                          <div className="service-cart-navigate">
                            <p style={{ color: 'white' }}>Total Price: Rs.{calculateTotalPrice()}</p>
                            <button onClick={() => navigate('/cart')}>View Cart</button>
                          </div>
                        </>
                      ) : (
                        <div className="empty-cart">
                          <img src={EmptyCartImg} alt="Empty Cart" />
                          <p>No items in your cart</p>
                        </div>
                      )}
                    </div>

                    <div className="offer-card">
                      <div className="offer-icon">
                        <span className="icon"><DiscountIcon style={{ color: 'green' }} /></span>
                      </div>
                      <div className="offer-details">
                        <h4 className="offer-title">Assured reward from CRED</h4>
                        <p className="offer-subtitle">On all online payments</p>
                        <Link href="#" className="more-offers">View More Offers ▼</Link>
                        <div className="offers-discount-offers"></div>
                      </div>
                    </div>
                    <div className="services-guidlines"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="about-services">
            <SofaCleaningInfo />
          </div>
        </div>
      </div>

      <Footer />

      <DetailsModal
        isOpen={isOpen}
        onClose={closeModal}
        service={selectedService}
      />
    </>
  );
};

export default Sofacleaning;
